import { useEffect } from 'react'
import { useQuery } from '@apollo/client'

import { config } from '../../components/Init/Init'
import { GET_FEATURED_FLAG_OVERRIDES } from '../../services/queries'
import { updateConfig } from '../../components/Init/configurationObject'
import { usePlayerStore } from '../../services/store'
import { filterByTags } from '../../services/utils'

export const useConfigOverride = () => {
  const featuredFlagOverridesQuery = useQuery(GET_FEATURED_FLAG_OVERRIDES)
  const playerStore = usePlayerStore()
  const playerTagsPlayer = playerStore.use.tagsPlayer()

  useEffect(() => {
    if (
      !config.enableConfigOverride ||
      !featuredFlagOverridesQuery ||
      !featuredFlagOverridesQuery.data ||
      !featuredFlagOverridesQuery.data.featureFlagOverridesEntries
    ) {
      return
    }

    let fetchedConfigs = []
    featuredFlagOverridesQuery.data.featureFlagOverridesEntries.forEach(e => {
      fetchedConfigs = fetchedConfigs.concat(e.featureFlagTagWidget)
    })

    let fetchedConfigsTagged = filterByTags(fetchedConfigs, 'featureFlagTag', playerTagsPlayer)

    const newConfig = { ...config }
    let isConfigChanged = false

    fetchedConfigs.forEach(e => {
      const isTagged = fetchedConfigsTagged.map(t => t.featureFlagKey).includes(e.featureFlagKey)
      if (newConfig[e.featureFlagKey] !== undefined && newConfig[e.featureFlagKey] !== isTagged) {
        isConfigChanged = true
        newConfig[e.featureFlagKey] = isTagged
      }
    })

    if (isConfigChanged) {
      updateConfig(newConfig)
    }
  }, [playerTagsPlayer, featuredFlagOverridesQuery])
}
